module.exports = __webpack_public_path__ + "img/close.6a4e5483.png";